<section class="page-container default-padding">
  <button mat-stroked-button routerLink="/dashboard">
    <mat-icon>keyboard_arrow_left</mat-icon>Back to Dashboard
  </button>
  <h3>{{ getUserFullName() }} | <span class="mat-title">Assessments</span></h3>
  <mat-divider></mat-divider>
  <mat-progress-bar *ngIf="loadingUserAssessments$ | async" mode="indeterminate"></mat-progress-bar>

  <section class="gtap-mt">
    <a mat-raised-button (click)='takeAssessment()' color="primary" class="mat-elevation-z5">
      Take a New Assessment
    </a>
  </section>

  <section class='user-assessments mat-elevation-z3' *ngIf='!(loadingUserAssessments$ | async) && userAssessments.length > 0; else noAssessments'>
    <div *ngFor='let assessment of userAssessments' class='assessment-item'>
      <span class='assessment-title'>{{assessment.name}}</span>
      <span>{{getAssessmentStatus(assessment)}}</span>
      <span>
        <button mat-button color='primary'
          (click)="continueAssessment(assessment)">{{getAssessmentAction(assessment)}}</button>
      </span>
    </div>
  </section>


  <ng-template #noAssessments>
    <div *ngIf='loadingUserAssessments$ | async; else notLoading'>
      <mat-spinner></mat-spinner>
      <h3>Setting up assessment.</h3>
    </div>

    <ng-template #notLoading>
      <div>
        <h3 *ngIf='!(loadingUserAssessments$ | async)'>You do not have any assessments.</h3>
        <mat-spinner *ngIf='loadingUserAssessments$ | async'></mat-spinner>
      </div>
    </ng-template>
  </ng-template>
</section>
